export interface IPaginationData {
	limit:number;
	offset:number;
	order:string;
	ascending:boolean;
}

export function paginationToQuery(p:IPaginationData):Object{
	return {
		limit: p.limit,
		offset: p.offset,
		order: p.order,
		orderDirection: p.ascending ? "ASC" : "DESC"
	};
}